<template>
  <div class="">
      <div class="status">
        <h2>{{ _getLanguage(languageKey) }}</h2>
        <a v-if="isEditable" @click.stop.prevent="removeLanguagePreset" class="btn btn_action btn_delete" :title="'Smazat' | translate" v-translate>Smazat</a>
        <a v-if="isEditable && isAddLanguageValueAllowed" class="add add_expand" :class="{ open: addLanguageSelectOpened && isAddLanguageValueAllowed}" @click.stop.prevent="_toggleAddLanguageValue" :title="$gettext('Přidat hodnotu')" v-translate>Přidat hodnotu</a>
      </div>

    <div class="filter expand_content" :class="{ open: addLanguageSelectOpened && isAddLanguageValueAllowed }">
      <div class="field_left">
        <select-box
            :id="'contentLanguagePresetsValues_'+languageKey"
            v-model="selectedLanguageValue"
            :options="availableLanguagesValuesOptions">
        </select-box>
      </div>

        <div class="field_right">
          <p class="field">
            <input class="btn" type="submit" :value="'Přidat' | translate" @click.stop.prevent="addLanguagePresetValue">
          </p>
        </div>
      </div>

      <table class="vypis vypis_detail">
        <tbody class="sortable" :class="'sortable_' + languageKey">
        <tr v-for="languageValue in languageValues" :rowid="languageValue" :class="'sorted_language_preset_values_' + languageKey" :key="'language_preset_value_' + languageValue">
          <td class="no_padding drag_drop" v-if="isEditable"><span></span></td>

        <td class="first_data no_padding_left">{{ _getLanguage(languageValue) }}</td>

          <td class="no_padding edit">
            <div class="edit_inner" v-if="isEditable">
              <a class="btn btn_action btn_delete" @click.stop.prevent="removeLanguagePresetValue(languageValue)" :title="'Smazat' | translate" v-translate>Smazat</a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
  </div>
</template>

<script>
import languages from "../../../mixins/languages";

export default {
  name: "LanguagePresets",
  props: {
    languagePresetsObject: Object,
    languageValues: Array,
    languageKey: String,
    isEditable: Boolean,
    allowedLanguages: Array,
  },
  mixins: [languages],
  mounted() {
    if (this.isEditable) {
      $('.sortable_' + this.languageKey).sortable({
        stop: this._updateSortedLanguagePresetValues
      });
    }
  },
  data() {
    return {
      addLanguageSelectOpened: false,
      selectedLanguageValue: null,
    };
  },
  methods: {
    removeLanguagePreset() {
      this.$emit('removeLanguagePreset', this.languageKey);
    },
    removeLanguagePresetValue(languageValue) {
      this.$emit('removeLanguagePresetValue', this.languageKey, languageValue);
    },
    addLanguagePresetValue() {
      this.$emit('addLanguagePresetValue', this.languageKey, this.selectedLanguageValue);
    },
    _toggleAddLanguageValue() {
      this.addLanguageSelectOpened = !this.addLanguageSelectOpened;
    },
    _getLanguage(value) {
      return this.$gettext(this.getLanguageNameByCode(value));
    },
    _updateSortedLanguagePresetValues() {
      const newLanguagePresetValuesSort = [];

      $('.sorted_language_preset_values_' + this.languageKey).each((el, x) => {
        newLanguagePresetValuesSort.push($(x).attr('rowid'));
      });
      this.$emit('sortLanguagePreset', this.languageKey, newLanguagePresetValuesSort);
    }
  },
  computed: {
    hasSelectableAllowedLanguages() {
      return !!this.allowedLanguages;
    },
    isAddLanguageValueAllowed() {
      return !this.hasSelectableAllowedLanguages || (this.hasSelectableAllowedLanguages && this.availableLanguagesValues.length > 0);
    },
    availableLanguagesValues() {
      return this.allowedLanguages ? this.allowedLanguages.filter((value) => {
        return !this.languageValues.includes(value);
      }) : [];
    },
    availableLanguagesValuesOptions() {
      const values = [];
      this.availableLanguagesValues.forEach((value) => {
        values.push({
          id: value,
          text: this.getLanguageNameByCode(value),
        });
      });

      if (this.availableLanguagesValues.length > 0 && !this.availableLanguagesValues.includes(this.selectedLanguageValue)) {
        this.selectedLanguageValue = this.availableLanguagesValues[0];
      }

      return values;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/forms/LanguagePresets.vue